export default __webpack_public_path__ + "static/media/8.382558c4.png";